import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

export default function slider(element, data) {
    const duration = data.duration || 1000;
    const delay = data.delay ?? 3000;

    const swiper = new Swiper(element, {
        modules: [Navigation, Pagination, Autoplay, EffectFade],
        loop: true,
        effect: "fade",
        fadeEffect: {
            crossFade: true,
        },
        speed: duration,
        autoplay: delay > 0 ? {
            delay: delay,
            disableOnInteraction: true,
            //pauseOnMouseEnter: true
        } : false,
        navigation: {
            addIcons: false,
            nextEl: element.querySelector('.swiper-button-next'),
            prevEl: element.querySelector('.swiper-button-prev'),
        },
        pagination: {
            el: element.querySelector('.swiper-pagination'),
            clickable: true,
        },
    });
}
